module.exports = __webpack_public_path__ + "img/location-check.408862bf.svg";